module.exports = __webpack_public_path__ + "static/media/start.65ca31fd.mp3";